import React, {useState, useEffect} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import axios from "axios";

const PurchaserequestShowComponent = (props) => {

  const {t} = props;
  const {action, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [statusDict, setStatusDict] = useState({});

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    apiCall('get', '/api/v2/dictionary/purchase-order-request-status')
      .then(response => {
        const items = Array.isArray(response?.data?.data) ? response.data.data : [];
        const map = items.reduce((acc, it) => {
          if (it?.key) acc[String(it.key).toUpperCase()] = String(it.value ?? '');
          return acc;
        }, {});
        setStatusDict(map);
      })
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response));


    if (id && action === 'read') {
      setLoading(true);
      apiCall('get', '/api/v2/purchase-order-request/' + id)
        .then(response => {
          setFormData(response.data.data)
          props.onLoaded(response.data.data || {});
          window.App.setState({ purchaserequestStatus: response.data.data?.status });
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [window.App.state.rerenderPurchaserequestShow, id])

  return (
    <div className={"purchaserequest-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="location">{t('columnPurchaseRequestNumber')}</label>
            <span className="p-d-block fake-input">
              {formData?.purchase_order_request_number}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="location">{t('columnDeliveryAddress')}</label>
            <span className="p-d-block fake-input">
              {formData?.location?.name}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="location">{t('columnProcurementPurpose')}</label>
            <span className="p-d-block fake-input">
              {t(formData?.reference_type?.toLowerCase())}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="project">{t('columnProject')}</label>
            <span className="p-d-block fake-input">
              {formData?.project?.name}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="project_item">{t('technology')}</label>
            <span className="p-d-block fake-input">
              {formData?.project_item?.name}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="created_at">{t('columnDeadline')}</label>
            <span className="p-d-block fake-input">
              {window.App.formatDateValue(formData.deadline)}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="created_by_name">{t('columnRequester')}</label>
            <span className="p-d-block fake-input">
              {formData.created_by?.name}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="last_name">{t('columnStatus2')}</label>
            <span className="p-d-block fake-input">
              {statusDict[String(formData?.status ?? '').toUpperCase()] ?? formData?.status ?? ''}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="created_at">{t('columnCreatedAt')}</label>
            <span className="p-d-block fake-input">
              {window.App.formatDateValue(formData.created_at)}
            </span>
          </div>
        </div>
        <div className={"p-col-12"}>
          <div className="p-field p-fluid">
            <label htmlFor="note">{t('columnComment')}</label>
            <span className="p-d-block fake-input">
              {formData?.note || ''}
            </span>
          </div>
        </div>
      </div>


    </div>
  )
}
export default withTranslation('common')(PurchaserequestShowComponent);
